module.exports = __webpack_public_path__ + "9170bb5a3b4e1246bc0e1373348860f8.pdf";